module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('wxc-mask', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "aria-hidden": "true",
      "mask-bg-color": "transparent",
      "overlay-opacity": "0.8",
      "show": _vm.show,
      "opacity": _vm.opacity,
      "show-close": false,
      "data-evt-wxcMaskSetHidden": ""
    },
    on: {
      "wxcMaskSetHidden": _vm.maskOverlayClick
    }
  }, [(_vm.show) ? _c('slider', {
    style: ({
      height: _vm._px2rem(_vm.height + 'px', 75)
    }),
    attrs: {
      "auto-play": "false",
      "index": _vm.index,
      "interval": _vm.interval
    }
  }, [_vm._l((_vm.imageList), function(v, index) {
    return _c('div', {
      key: index,
      staticClass: " weex-ct weex-div",
      style: ({
        height: _vm._px2rem(_vm.height + 'px', 75)
      }),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('figure', {
      directives: [{
        name: "weex-resize",
        rawName: "v-weex-resize",
        value: ("cover"),
        expression: "\"cover\""
      }],
      staticClass: " weex-el weex-image",
      style: ({
        height: _vm._px2rem(_vm.height + 'px', 75),
        width: _vm._px2rem(_vm.width + 'px', 75)
      }),
      attrs: {
        "resize": "cover",
        "src": v.src,
        "data-img-src": v.src,
        "weex-type": "image"
      }
    })])
  }), _vm._v(" "), (_vm.showIndicator) ? _c('indicator', {
    staticClass: "indicator",
    style: (_vm._px2rem(_vm.indicatorStyle, 75)),
    attrs: {}
  }) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a4179e68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4179e68","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-lightbox/index.vue
// module id = 237
// module chunks = 0 1